import { useDeclarations } from '../hooks/useDeclarations';
import {
  DECLARATION_KIND,
  DECLARATION_KIND_LABELS,
} from '../types/taxFilings.types';
import { SignedDeclarationDropzone } from './SignedDeclarationDropzone';
import {
  StatusBadge,
  TaxFilingDocumentRow,
  TaxFilingEmptyState,
  TaxFilingErrorState,
  TaxFilingLoadingState,
} from './TaxFilingDocumentRow';

export function DeclarationsTab() {
  const {
    documents,
    isLoading,
    error,
    isUploading,
    getPreviewUrl,
    uploadSigned,
  } = useDeclarations();

  const unsigned = documents.filter((d) => d.kind === DECLARATION_KIND.UNSIGNED);
  const signed = documents.filter((d) => d.kind === DECLARATION_KIND.SIGNED);

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-foreground">Unsigned</h3>
        <p className="text-xs text-muted-foreground">
          Download the unsigned declaration, sign it, then upload the signed copy below.
        </p>
        {isLoading ? (
          <TaxFilingLoadingState />
        ) : error ? (
          <TaxFilingErrorState message={error} />
        ) : unsigned.length === 0 ? (
          <TaxFilingEmptyState
            title="No unsigned declaration"
            description="Your preparer has not uploaded an unsigned declaration yet."
          />
        ) : (
          <div className="space-y-2">
            {unsigned.map((doc) => (
              <TaxFilingDocumentRow
                key={doc.id}
                document={doc}
                getPreviewUrl={getPreviewUrl}
                badge={
                  <StatusBadge
                    label={DECLARATION_KIND_LABELS[DECLARATION_KIND.UNSIGNED]}
                    variant="outline"
                  />
                }
              />
            ))}
          </div>
        )}
      </div>

      <div className="space-y-2">
        <h3 className="text-sm font-semibold text-foreground">Signed</h3>
        <p className="text-xs text-muted-foreground">
          Upload your signed declaration here.
        </p>
        <SignedDeclarationDropzone
          onUpload={uploadSigned}
          isUploading={isUploading}
        />
        {!isLoading && !error && signed.length === 0 && (
          <p className="text-xs text-muted-foreground pt-1">
            No signed declaration uploaded yet.
          </p>
        )}
        {signed.length > 0 && (
          <div className="space-y-2 pt-2">
            {signed.map((doc) => (
              <TaxFilingDocumentRow
                key={doc.id}
                document={doc}
                getPreviewUrl={getPreviewUrl}
                badge={
                  <StatusBadge
                    label={DECLARATION_KIND_LABELS[DECLARATION_KIND.SIGNED]}
                    variant="default"
                  />
                }
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
